import { push } from "connected-react-router";
import { useAppDispatch } from "store/hooks";
import { IEvent } from "../types";
import { useCheckEventStatus } from "./useCheckEventStatus";

const useEventUtils = () => {
  const { checkIsAllowedToJoinEvent, checkIfEventEnded } =
    useCheckEventStatus();
  const dispatch = useAppDispatch();

  /**
   * Checks if current user is allowed to view event
   * @param eventId
   */
  const isAllowedToViewEvent = (
    event: IEvent,
    isEventManager: boolean,
    isSpeaker: boolean,
  ) => {
    const { status, code } = event;
    const isPast = checkIfEventEnded(event);

    // if admin or event not ended, should go into event
    // For speakers and attendess if event ended, should show message
    if (isEventManager || isSpeaker) {
      return true;
    }

    if (status === "archived" || status === "inactive" || isPast) {
      dispatch(push(`/e/${code}/register?action=EVENT_ENDED`));

      return false;
    }

    if (!checkIsAllowedToJoinEvent(event)) {
      dispatch(push(`/e/${code}/register`));

      return false;
    }

    return true;
  };

  return {
    isAllowedToViewEvent,
  };
};

export default useEventUtils;
